// ------------------ config (static)
/* eslint-disable-next-line no-unused-vars */
const CONFIG = (() => {
	// private var(s)
	const _googleMapsKey = '';

	// private method(s)
	const _constructor = () => {
		// console.log('Config is running');
	};
	
	const _VIMO_KOREA_DOMAIN = "vimo.kr"

	_constructor();

	// output/public
	return {
		googleMapsKey: _googleMapsKey,
		VIMO_KOREA_DOMAIN: _VIMO_KOREA_DOMAIN
	};
})();
